import { findProvinceByStateCode } from '@dfl/location';

const ProvinceStringValue = ({ provinceCode }: { provinceCode: string }) => {
  return <>{findProvinceByStateCode(provinceCode)?.name || provinceCode}</>;
};

export default ProvinceStringValue;
